import React from "react";
import "./INeedToThree.css"

const INeedToThree = () => (
  <div className='INeedToThree'>

	<h1>Priority</h1>

  <p>Each task in an iNeed2 task list has four attributes:</p>
<ul>

  <li>Urgency - How urgent is the task? Perhaps this should be labeled
    "how badly does my supervisor (or wife, or husband) want me to get 
    this done quickly"?
  </li> 
  
  <li>Importance - How important is the task? Maybe this should be 
    labeled "how important do I think this is."
  </li>

  <li>Effort - How much effort will be required to do this task?
    </li>
<li>Completeness - How much of this task has already been completed?
  </li>

</ul>

<p>The iNeed2 webpages allow the weights of the different parameters 
  to be varied in determining the priorities of the tasks. Also this 
  is VERY easily done from the settings screen. 
  </p>
  
  <p>Do you need to get in the good graces of your supervisor 
    (or wife or husband)? Set the weight of importance to zero, 
    the weight of urgency at one hundred, effort at -50 and 
    completion at +50. That will mean that the most urgent 
    and most easily completed tasks will have the 
  highest priority.</p>
  
  <p>Want to clear your task list? Set the weights 
  of both urgency and importance to zero and the weight of effort 
  at negative one hundred and the weight of completion at positive 
  one hundred. Then, the highest priority items will be the ones 
  that can be completed quickly.</p>

	

  </div>
);

export default INeedToThree;


// WEBPACK FOOTER //
// ./src/components/iNeed2_Slides/INeedToThree.js